import { Store } from 'vuex'
import { State } from '@/store'

export function initApi(store: Store<State>): void {
  console.log(store);
  // globalStore = store;
  //
}